// Angular
import { NgModule } from '@angular/core';

// Afidium
import { FlightDetailsComponent } from './flight-details.component';
import { FlightDetailsService } from './flight-details.service';
import { SectorAirFlightDetailsModule } from "libraries/component/sector-air-flight-details/sector-air-flight-details.module";
import { CommonModule } from '@angular/common';
import { DatePipeModule } from 'libraries/date/date.module';
import { DateModule } from 'libraries/module/formbuilder/fields/date/date.module';
import { BtnModule } from "libraries/ui_button/btn.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ClickStopModule } from 'libraries/directive/clickstop/click-stop.module';

@NgModule({
    imports: [
        BtnModule,
        CommonModule,
        DateModule,
        DatePipeModule,
        SectorAirFlightDetailsModule,
        FontAwesomeModule,
        ClickStopModule,
    ],
    exports: [FlightDetailsComponent],
    declarations: [FlightDetailsComponent],
    providers: [FlightDetailsService]
})
export class FlightDetailsModule { }
